import createReactComponent from '../createReactComponent';
export default createReactComponent(
  'device-ipad-check',
  'IconDeviceIpadCheck',
  [
    [
      'path',
      {
        d: 'M11.5 21h-5.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v8',
        key: 'svg-0',
      },
    ],
    ['path', { d: 'M9 18h2', key: 'svg-1' }],
    ['path', { d: 'M15 19l2 2l4 -4', key: 'svg-2' }],
  ],
);
